

export const DirectusImage = ( { image, size, classy } ) => (
    <div>
        {image && <img src={process.env.PREACT_APP_API_URL+'/assets/'+image.id+'?fit=cover&width=768&height=900&quality=80'} class={classy} />}
    </div>
);